import React, { useMemo, useContext } from 'react';
import styled from 'styled-components';
import { Booth } from 'models/cms/booths';
import { BoothContext } from 'pages/booths/BoothProfileContainer';

import FileArrow from 'components/icons/FileArrow';
import BoothContainer from '../../components/BoothContainer';
import GenericCMSBoothBanner from '../../components/GenericCMSBoothBanner';
import BoothSaleContainer, { SaleInfoContainer, BubbleArrow } from '../BoothSaleContainer';
import BoothBackground from './BoothBackground';

const TopBannerContainer = styled.div`
  position: absolute;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 414px;
  height: 155px;
  top: 12px;
  left: calc((90% - 578px) / 2);
  z-index: 2;
`;

const BackgroundContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: -50px;
`;

const PullUpBannerContainer = styled.div`
  position: absolute;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 133px;
  height: 284px;
  top: 327px;
  left: calc((90% + 727px) / 2);
  z-index: 2;
`;

const SaleContainer = styled.div`
  position: absolute;
  width: 200px;
  height: 434px;
  left: 965px;
  bottom: 30px;
  z-index: 2;

  & ${SaleInfoContainer} {
    left: -132px;
  }

  & ${BubbleArrow} {
    left: 73%;
  }
`;

const CenterBannerContainer = styled.div`
  position: absolute;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 278px;
  height: 155px;
  top: 284px;
  left: calc((90% - 450px) / 2);
  z-index: 2;
`;

const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 900px;
`;

const StyledBoothContainer = styled(BoothContainer)`
  width: 1025px;
  height: 660px;
  left: ${({ needOffset }) => (needOffset ? 'unset' : '-50px')};
  bottom: ${({ needOffset }) => (needOffset ? 'unset' : '95px')};
  transform: ${({ needOffset }) => (needOffset ? 'unset' : 'scale(0.8)')};
`;

const BrochureContainer = styled.div<{ enableClick: boolean }>`
  cursor: ${({ enableClick }) => (enableClick ? 'pointer' : 'initial')};
  position: absolute;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 117px;
  height: 278px;
  top: 338px;
  left: calc((90% - 740px) / 2);
  z-index: 2;
`;

export interface BannerProps {
  booth: Booth;
  handleClick: (type: string) => void;
  isPreview?: boolean;
}

const ArrowContainer = styled.div`
  position: absolute;
  left: 22px;
  top: 24px;
`;

const Banner: React.FC<BannerProps> = ({
  booth,
  handleClick = () => null,
  isPreview = false,
}: BannerProps) => {
  const {
    pullUpBanner, topBanner, centerBanner, themeColor,
  } = useMemo(() => {
    const elements = (booth.designElements || []).filter((it) => it?.name);
    return ({
      pullUpBanner: elements.find((designNode) => designNode.name === 'pull_up_banner'),
      topBanner: elements.find((designNode) => designNode.name === 'top_banner'),
      centerBanner: elements.find((designNode) => designNode.name === 'middle_banner'),
      themeColor: elements.find((designNode) => designNode.name === 'theme_color')?.color || '#52A4D1',
    });
  }, [booth.designElements]);

  const boothForMatomo = useContext(BoothContext);

  const onBannerClick = (key) => {
    window.trackingItemToFirebase(null, 'Booth', 'Banner', key, key, boothForMatomo.id, boothForMatomo.boothNameForMatomo);
  };

  return (
    <RootContainer>
      <StyledBoothContainer needOffset={!isPreview}>
        <BackgroundContainer>
          <BoothBackground themeColor={themeColor} />
        </BackgroundContainer>
        <TopBannerContainer onClick={() => onBannerClick('Banner 2_Click')}>
          <GenericCMSBoothBanner
            onBannerClick={handleClick as any}
            autoPlayVideo={!isPreview}
            bannerData={topBanner}
          />
        </TopBannerContainer>
        <CenterBannerContainer onClick={() => onBannerClick('Banner 3_Click')}>
          <GenericCMSBoothBanner
            onBannerClick={handleClick as any}
            autoPlayVideo={!isPreview}
            bannerData={centerBanner}
          />
        </CenterBannerContainer>
        <PullUpBannerContainer onClick={() => onBannerClick('Banner 1_Click')}>
          <GenericCMSBoothBanner
            onBannerClick={handleClick as any}
            autoPlayVideo={!isPreview}
            bannerData={pullUpBanner}
          />
        </PullUpBannerContainer>
        {!isPreview && (
          <BrochureContainer enableClick={booth.hasAttachment} onClick={() => handleClick('attachment')}>
            {booth.hasAttachment && (
              <ArrowContainer>
                <FileArrow color={themeColor as any} width={40} height={40} />
              </ArrowContainer>
            )}
          </BrochureContainer>
        )}
        {
          !isPreview && (
            <SaleContainer>
              <BoothSaleContainer booth={booth} sale="male-right" />
            </SaleContainer>
          )
        }
      </StyledBoothContainer>
    </RootContainer>
  );
};

export default Banner;
